import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const RefreshButton = React.memo(({ onClick, position = "absolute", zIndex, className}) => {
    return (
        <div className={`${position} z-${zIndex || 10} ${className || "bottom-3 right-4"}`} >
            <div onClick={onClick} className='cursor-pointer bg-red-600 px-2.5 py-2 rounded-full hoverRed'>
                <FontAwesomeIcon icon={faRotateRight} size={"lg"} style={{ color: "#ffffff", }} />
            </div>
        </div>
    );
})

export default RefreshButton;
